<app-layout>
    <!-- components title start -->
    <div class="components-title">
        <h2>Create Ad</h2>
    </div>
    <!-- components title end -->

    <div class="flex w-full">
        <div class="inline-flex rounded-lg my-3 bg-opacity-30 overflow-hidden w-full lg:w-1/2">
            <button @click="setType('buy')" :class="{'border-indigo-500 bg-indigo-500 text-white': type == 'buy'}" class="w-full lg:w-1/2 rounded-l-lg  py-[10px] py-2 my-1 px-[12px] px-6 inline-flex items-center justify-center font-medium border text-center focus:outline-none text-black text-sm sm:text-base capitalize bg-gray-200">{{ $t('I want to buy') }}</button>
            <button @click="setType('sell')" :class="{'border-indigo-500 bg-indigo-500 text-white': type == 'sell'}" class="w-full lg:w-1/2 rounded-r-lg py-[10px] py-2 my-1 px-[12px] px-6 inline-flex items-center justify-center font-medium border text-center focus:outline-none text-black text-sm sm:text-base capitalize bg-gray-200">{{ $t('I want to sell') }}</button>
        </div>
    </div>

    <div class="components-filter mt-10">
        <div class="components-filter__row">
            <div class="components-filter__item">
                <label>{{ $t('Asset') }}</label>
                <t-rich-user-select
                    :options="currencies.data"
                    v-model="form.currency"
                    :placeholder="$t('Select currency')"
                    value-attribute="id"
                    text-attribute="name"
                    :clearable="false"
                >
                    <template
                        slot="label"
                        slot-scope="{ className, option, query }"
                    >
                        <div class="flex">
                            <div class="flex flex-col">
                                <div class="swap-label flex items-stretch">
                                    <img src="/images/swap.png" width="28" />
                                    <span class="pt-1 ml-5">{{ option.text }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template
                        slot="option"
                        slot-scope="{ className, option, query }"
                    >
                        <div class="flex">
                            <div class="flex flex-col">
                                <div class="flex items-stretch pt-2 pb-2 pl-2">
                                    <img src="/images/swap.png" width="28" />
                                    <span class="pt-1 ml-5">{{ option.text }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </t-rich-user-select>
            </div>
            <div class="components-filter__item">
                <label>{{ $t('with Cash') }}</label>
                <t-rich-user-select
                    :options="currencies.data"
                    v-model="form.fiat"
                    :placeholder="$t('Select fiat currency')"
                    value-attribute="id"
                    text-attribute="name"
                    :clearable="false"
                >
                    <template
                        slot="label"
                        slot-scope="{ className, option, query }"
                    >
                        <div class="flex">
                            <div class="flex flex-col">
                                <div class="swap-label flex items-stretch">
                                    <img src="/images/swap.png" width="28" />
                                    <span class="pt-1 ml-5">{{ option.text }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template
                        slot="option"
                        slot-scope="{ className, option, query }"
                    >
                        <div class="flex">
                            <div class="flex flex-col">
                                <div class="flex items-stretch pt-2 pb-2 pl-2">
                                    <img src="/images/swap.png" width="28" />
                                    <span class="pt-1 ml-5">{{ option.text }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </t-rich-user-select>
            </div>
        </div>
    </div>

    <div class="components-filter mt-10">
        <div class="components-filter__row">

            <div class="components-filter__item">
                <label>{{ $t('Payment time limit') }}</label>
                <t-rich-user-select
                    :options="[{'id': '15', 'name': '15 min'},{'id': '30', 'name': '30 min'}, {'id': '45', 'name': '45 min'}, {'id': '60', 'name': '1 hr'}, {'id': '120', 'name': '2 hr'}, {'id': '180', 'name': '3 hr'}]"
                    v-model="form.status"
                    :placeholder="$t('Select period')"
                    value-attribute="id"
                    text-attribute="name"
                    :clearable="true"
                >
                    <template
                        slot="label"
                        slot-scope="{ className, option, query }"
                    >
                        <div class="flex">
                            <div class="flex flex-col">
                                <span>{{ option.text }}</span>
                            </div>
                        </div>
                    </template>
                </t-rich-user-select>
            </div>

            <div class="components-filter__item">
                <label>{{ $t('Total amount') }}</label>
                <input placeholder="0.00" type="text" v-model="form.amount" @keyup="(e) => clearInput(e, 'amount')" @keypress="(e) => handleInput(e, 'amount')" @paste.prevent @drop.prevent   class="filter-select w-full rounded flex text-left mt-1 justify-between items-center px-3 py-2 transition duration-100 ease-in-out focus:border-gray-200 focus:ring-2 focus:ring-gray-200 focus:outline-none focus:ring-opacity-10 disabled:opacity-50 disabled:cursor-not-allowed bg-white border-gray-200" />
            </div>
        </div>
    </div>
    <div class="components-filter mt-10">
        <div class="components-filter__row">
            <div class="components-filter__item">
                <label>{{ $t('Minimum amount') }}</label>
                <input placeholder="0.00" type="text" v-model="form.min_amount" @keyup="(e) => clearInput(e, 'min_amount')" @keypress="(e) => handleInput(e, 'min_amount')" @paste.prevent @drop.prevent   class="filter-select w-full rounded flex text-left mt-1 justify-between items-center px-3 py-2 transition duration-100 ease-in-out focus:border-gray-200 focus:ring-2 focus:ring-gray-200 focus:outline-none focus:ring-opacity-10 disabled:opacity-50 disabled:cursor-not-allowed bg-white border-gray-200" />
            </div>
            <div class="components-filter__item">
                <label>{{ $t('Maximum amount') }}</label>
                <input placeholder="0.00" type="text" v-model="form.max_amount" @keyup="(e) => clearInput(e, 'max_amount')" @keypress="(e) => handleInput(e, 'max_amount')" @paste.prevent @drop.prevent   class="filter-select w-full rounded flex text-left mt-1 justify-between items-center px-3 py-2 transition duration-100 ease-in-out focus:border-gray-200 focus:ring-2 focus:ring-gray-200 focus:outline-none focus:ring-opacity-10 disabled:opacity-50 disabled:cursor-not-allowed bg-white border-gray-200" />
            </div>
        </div>
    </div>



</app-layout>
